import { render, staticRenderFns } from "./PetrolEmissionTable.vue?vue&type=template&id=628af6f2&scoped=true"
import script from "./PetrolEmissionTable.vue?vue&type=script&lang=js"
export * from "./PetrolEmissionTable.vue?vue&type=script&lang=js"
import style0 from "./PetrolEmissionTable.vue?vue&type=style&index=0&id=628af6f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "628af6f2",
  null
  
)

export default component.exports